import { Injectable } from '@angular/core';
import { SimpleAuthenticationStorageService } from '@aston/foundation';
import { AbstractSecurityStorage } from 'angular-auth-oidc-client';

@Injectable({providedIn: 'root'})
export class AuthenticationStorageService
	extends SimpleAuthenticationStorageService
	implements AbstractSecurityStorage
{
	// eslint-disable-next-line @typescript-eslint/class-literal-property-style
	get ns() {
		return 'C'
	}
}
